module.exports = __webpack_public_path__ + "static/media/blog2_sm.bf9c654f.webp";